import { Component, Input } from '@angular/core';
import { CalloutContent, CalloutEmphasis } from '@common/entities';

@Component({
  standalone: false,
  selector: 'common-callout-content',
  templateUrl: './callout-content.component.html',
  styleUrls: ['./callout-content.component.scss'],
})

//This component can take in a title, submittedOn, and isSubmitted from the calling component
//If submittedOn is not passed in, it will query the application based on applicationId
export class CalloutContentComponent {
  @Input() calloutContent: CalloutContent;
  @Input() calloutWrapperClass = ''; //often used to set max width on the callout
  @Input() defaultEmphasis = CalloutEmphasis.Medium;
}
